import React, { useContext } from "react";
import { LimpiarSelectReceta } from "../../../context/Actions/DropDownFamiliares/selectFamiliares";
import { hideModal } from "../../../context/Actions/modal/modal";
import { hideSegundoModal } from "../../../context/Actions/segundoModal/segundoModal";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import {
  setListErrorReceta,
  setReceta,
  wsPostFormularioReceta,
} from "../../../context/Actions/turnos/recetaDigital";
import { PortalContext } from "../../../context/Provider";
import selectDropDown from "../../../context/reducers/selectDropDown";
import camelize from "../../../../global/utils/camelize";
import { farmaciasData } from "../../../../global/utils/farmacias";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import HeaderModal from "../../Genericos/headerModal/headerModal";
import "./FormularioReceta.css";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../../Genericos/InputV1/InputV1";

const FormularioReceta = ({ titulo, dissmiss }) => {
  const {
    recetasDigitalesState,
    recetasDigitalesDispatch,
    segundoModalDispatch,
    selectDropDownDispatch,
  } = useContext(PortalContext);

   // Cambio de contexto
   const {
    authState,
    authDispatch,
    toasterDispatch, 
  } = useContext(GlobalContext);



  const campos = [
    "dni",
    "nombre",
    "telefono",
    "seAtendio",
    "horario",
    "nombreMedico",
    "farmacia",
    "nombreFarmaceutico",
    "numMatriculaFarmaceutico",
  ];
  const regexNombre = /^[a-zA-Z ]+(\s+[a-zA-Z]+)*$/;
  const isNombreError = (nombre) => {
    if (regexNombre.test(nombre)) {
      return false;
    }
    if (nombre === "") {
      return true;
    }
  };
  const isEmptyError = (empty) => {
    if (empty === "") {
      return true;
    }
    return false;
  };

  const onChangeNroDocumento = (e) => {
    let receta = Object.assign(
      {},
      recetasDigitalesState.recetasDigitales.receta
    );
    let errx = Object.assign(
      {},
      recetasDigitalesState.recetasDigitales.listErrorReceta
    );
    errx.dni = isEmptyError(e.target.value);
    setListErrorReceta(errx)(recetasDigitalesDispatch);
    receta.dni = e.target.value;
    setReceta(receta)(recetasDigitalesDispatch);
  };

  const onNombreChange = (e) => {
    let receta = Object.assign(
      {},
      recetasDigitalesState.recetasDigitales.receta
    );
    let errx = Object.assign(
      {},
      recetasDigitalesState.recetasDigitales.listErrorReceta
    );
    errx.nombre = isNombreError(e.target.value);
    setListErrorReceta(errx)(recetasDigitalesDispatch);
    receta.nombre = e.target.value;
    setReceta(receta)(recetasDigitalesDispatch);
  };

  const onChangeTelefono = (e) => {
    let receta = Object.assign(
      {},
      recetasDigitalesState.recetasDigitales.receta
    );
    let errx = Object.assign(
      {},
      recetasDigitalesState.recetasDigitales.listErrorReceta
    );
    errx.telefono = isEmptyError(e.target.value);
    setListErrorReceta(errx)(recetasDigitalesDispatch);
    receta.telefono = e.target.value;
    setReceta(receta)(recetasDigitalesDispatch);
  };

  const onChangeRadioAtencion = (e) => {
    let receta = Object.assign(
      {},
      recetasDigitalesState.recetasDigitales.receta
    );
    let errx = Object.assign(
      {},
      recetasDigitalesState.recetasDigitales.listErrorReceta
    );
    errx.seAtendio = isEmptyError(e.target.value);
    setListErrorReceta(errx)(recetasDigitalesDispatch);
    if (e.target.value === "true") {
      receta.seAtendio = "Si";
      setReceta(receta)(recetasDigitalesDispatch);
    } else {
      receta.seAtendio = "No";
      setReceta(receta)(recetasDigitalesDispatch);
    }
  };
  const onChangeRadioHorario = (e) => {
    let receta = Object.assign(
      {},
      recetasDigitalesState.recetasDigitales.receta
    );
    let errx = Object.assign(
      {},
      recetasDigitalesState.recetasDigitales.listErrorReceta
    );
    errx.horario = isEmptyError(e.target.value);
    setListErrorReceta(errx)(recetasDigitalesDispatch);
    if (e.target.value === "true") {
      receta.horario = "Por la mañana - De 8 a 12 hs.";
      setReceta(receta)(recetasDigitalesDispatch);
    } else {
      receta.horario = "Por la tarde - De 12 a 17 hs.";
      setReceta(receta)(recetasDigitalesDispatch);
    }
  };

  const onChangeNombreMedico = (e) => {
    let receta = Object.assign(
      {},
      recetasDigitalesState.recetasDigitales.receta
    );
    let errx = Object.assign(
      {},
      recetasDigitalesState.recetasDigitales.listErrorReceta
    );
    errx.nombreMedico = isNombreError(e.target.value);
    setListErrorReceta(errx)(recetasDigitalesDispatch);
    receta.nombreMedico = e.target.value;
    setReceta(receta)(recetasDigitalesDispatch);
  };

  const onChangeDropdownFarmacia = (e) => {
    let receta = Object.assign(
      {},
      recetasDigitalesState.recetasDigitales.receta
    );
    if (e.id !== undefined) {
      receta.farmacia = e.nombre;
      setReceta(receta)(recetasDigitalesDispatch);
    }
  };
  const onChangeNombreFarmaceutico = (e) => {
    let receta = Object.assign(
      {},
      recetasDigitalesState.recetasDigitales.receta
    );
    receta.nombreFarmaceutico = e.target.value;
    setReceta(receta)(recetasDigitalesDispatch);
  };

  const onChangeMatricula = (e) => {
    let receta = Object.assign(
      {},
      recetasDigitalesState.recetasDigitales.receta
    );
    receta.numMatriculaFarmaceutico = e.target.value;
    setReceta(receta)(recetasDigitalesDispatch);
  };

  const enviarRecetaDigital = () => {
    let errx = Object.assign(
      {},
      recetasDigitalesState.recetasDigitales.listErrorReceta
    );
    errx.nombre = isNombreError(
      recetasDigitalesState.recetasDigitales.receta.nombre
    );
    errx.dni = isEmptyError(recetasDigitalesState.recetasDigitales.receta.dni);
    errx.seAtendio = isEmptyError(
      recetasDigitalesState.recetasDigitales.receta.seAtendio
    );
    errx.horario = isEmptyError(
      recetasDigitalesState.recetasDigitales.receta.horario
    );
    errx.nombreMedico = isNombreError(
      recetasDigitalesState.recetasDigitales.receta.nombreMedico
    );
    //consulto nuevamente si ya tenia el error, ya que estoy validando contra el ws.
    if (!recetasDigitalesState.recetasDigitales.receta.telefono) {
      errx.telefono = isEmptyError(
        recetasDigitalesState.recetasDigitales.receta.telefono
      );
    }
    setListErrorReceta(errx)(recetasDigitalesDispatch);
    let flgError = false;
    campos.forEach((item) => {
      if (errx[item]) flgError = true;
    });
    if (flgError) {
      showToaster(
        {
          texto:
            "Por favor, ingresá todos los campos requeridos en el formulario.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    } else {
      wsPostFormularioReceta(recetasDigitalesState.recetasDigitales.receta)(
        recetasDigitalesDispatch
      );
      LimpiarSelectReceta()(selectDropDownDispatch);
      hideSegundoModal()(segundoModalDispatch);
    }
  };

  return (
    <React.Fragment>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} />
      <div className="ptur-modalReceta-body">
        <div className="ptur-modalReceta-titulo">
          <p className="rb32b c-latex10">Completá el formulario</p>
          <p className="rb18b c-latex10">
            Una vez enviado podemos generar la receta digital
          </p>
        </div>
        <div className="ptur-modalReceta-input1">
          <InputV1
            className="ptur-modalReceta-textarea"
            inputType="text"
            name="documento"
            headerStr="Tu número de documento (DNI)*"
            placeholderText="12345678"
            onChange={onChangeNroDocumento}
            checkError={
              recetasDigitalesState.recetasDigitales.listErrorReceta.dni
            }
            errorStr="El dni es requerido"
            maxLength="8"
            isRequired={true}
            value={recetasDigitalesState.recetasDigitales.receta.dni}
          />
          <InputV1
            className="ptur-modalReceta-textarea"
            inputType="text"
            name="nombre"
            headerStr="Nombre completo*"
            placeholderText="Dominguez"
            onChange={onNombreChange}
            checkError={
              recetasDigitalesState.recetasDigitales.listErrorReceta.nombre
            }
            errorStr="El nombre es requerido"
            isRequired={true}
            value={recetasDigitalesState.recetasDigitales.receta.nombre}
          />
        </div>
        <div className="ptur-modalReceta-input2">
          <InputV1
            className="ptur-modalReceta-textarea"
            inputType="text"
            name="telefono"
            headerStr="Teléfono de contacto*"
            placeholderText="15512345678"
            onChange={onChangeTelefono}
            checkError={
              recetasDigitalesState.recetasDigitales.listErrorReceta.telefono
            }
            errorStr="El telefono es requerido"
            maxLength="10"
            isRequired={true}
            value={recetasDigitalesState.recetasDigitales.receta.telefono}
          />
          <div className="ptur-modalReceta-opciones">
            <p className="rb14m">
              Se atiendio alguna vez en DIM?<span className="c-danger"> *</span>
            </p>
            <div className="ptur-modalReceta-radioAtencion">
              <div className="ptur-modalReceta-radioAtencion-opciones">
                <InputV1
                  className="ptur-modalReceta-radio"
                  inputType="radio"
                  labelStr="Si"
                  nombreRadio="atendioDIM"
                  name="siAtendio"
                  onChange={onChangeRadioAtencion}
                  checkError={
                    recetasDigitalesState.recetasDigitales.listErrorReceta
                      .seAtendio
                  }
                  value={true}
                  isRequired={true}
                />
                <InputV1
                  inputType="radio"
                  labelStr="No"
                  nombreRadio="atendioDIM"
                  name="noAtendio"
                  onChange={onChangeRadioAtencion}
                  checkError={
                    recetasDigitalesState.recetasDigitales.listErrorReceta
                      .seAtendio
                  }
                  value={false}
                  isRequired={true}
                />
              </div>
              <div className="ptur-modalReceta-radioAtencion-textoError c-danger rb12m">
                {recetasDigitalesState.recetasDigitales.listErrorReceta
                  .seAtendio ? (
                  <p>El campo es requerido</p>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="ptur-modalReceta-disponibilidad">
          <p className="rb14m">
            Cual es su disponibilidad horaria?
            <span className="c-danger"> *</span>
          </p>
          <div className="ptur-modalReceta-radioDisponibilidad rb16l">
            <InputV1
              inputType="radio"
              labelStr="Por la mañana - De 8 a 12 hs."
              nombreRadio="dispHoraria"
              name="manana"
              onChange={onChangeRadioHorario}
              isRequired={true}
              checkError={
                recetasDigitalesState.recetasDigitales.listErrorReceta.horario
              }
              errorStr={
                typeof window.orientation !== "undefined"
                  ? ""
                  : "El campo es requerido"
              }
              value={true}
            />
            <InputV1
              inputType="radio"
              labelStr="Por la tarde - De 12 a 17 hs."
              nombreRadio="dispHoraria"
              name="tarde"
              onChange={onChangeRadioHorario}
              isRequired={true}
              checkError={
                recetasDigitalesState.recetasDigitales.listErrorReceta.horario
              }
              errorStr={
                typeof window.orientation !== "undefined"
                  ? "El campo es requerido"
                  : ""
              }
              value={false}
            />
          </div>
        </div>
        <div className="ptur-modalReceta-medicoHabitual">
          <InputV1
            className="ptur-modalReceta-textarea"
            inputType="text"
            name="medico"
            headerStr="Medico con el que se atiende habitualmente*"
            placeholderText="Nombre del médico"
            onChange={onChangeNombreMedico}
            checkError={
              recetasDigitalesState.recetasDigitales.listErrorReceta
                .nombreMedico
            }
            errorStr="El nombre del medico es requerido"
            isRequired={true}
          />
        </div>
        <div className="ptur-modalReceta-farmacia">
          <Dropdown
            headerStr="A fines de cumplir con los requerimientos de algunas farmacias para recibir las órdenes médicas, ¿Puede indicarnos en qué Farmacia adquirirá el medicamento?"
            datos={farmaciasData}
            onChange={onChangeDropdownFarmacia}
            value={recetasDigitalesState.recetasDigitales.receta.farmacia}
            campoCodigo="id"
            descripcion="nombre"
            placeholder="Elegi una opción"
            campoDescripcion={"nombre"}
            name="txtFarmacia"
            errorStr="La Farmacia es requerida"
            isRequired={false}
            notSearch={true}
          />
        </div>
        {/* <div className="ptur-modalReceta-farmaceutico">
          <InputV1
            className="ptur-modalReceta-textarea"
            inputType="text"
            name="farmaceutico"
            headerStr="¿Podría indicarnos el nombre del farmacéutico de dicha farmacia?"
            placeholderText="Nombre del farmacéutico"
            onChange={onChangeNombreFarmaceutico}
            isRequired={false}
          />
        </div>
        <div className="ptur-modalReceta-matriculaFarmaceutico">
          <InputV1
            className="ptur-modalReceta-textarea"
            inputType="text"
            name="matricula"
            headerStr="¿Podría indicarnos el número de matrícula del farmacéutico si es que lo tiene?"
            placeholderText="Matrícula del farmacéutico"
            onChange={onChangeMatricula}
            isRequired={false}
          />
        </div> */}
        <div className="ptur-modalReceta-botonContainer">
          <button
            className="rb16m bgc-primary c-white ptur-modalReceta-boton"
            onClick={() => enviarRecetaDigital()}
          >
            Enviar
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FormularioReceta;
